import { useEffect, useState } from "react";
import { Loader2, ShieldAlert } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const STATUSES = ["open", "in_progress", "resolved"];
const statusColor = {
  open: "bg-red-100 text-red-700",
  in_progress: "bg-amber-100 text-amber-800",
  resolved: "bg-green-100 text-green-800",
};

export default function ComplaintsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/complaints").then((r) => { setItems(r.data); setLoading(false); });
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, []);

  const setStatus = async (id, status) => { await api.put(`/complaints/${id}`, { status }); toast.success("Updated"); load(); };

  return (
    <div className="space-y-6" data-testid="complaints-page">
      <div>
        <h1 className="text-3xl text-foreground mb-1">Complaints</h1>
        <p className="text-muted-foreground text-sm">Issues reported by guests from their room.</p>
      </div>

      {loading ? <Loader2 className="w-5 h-5 animate-spin text-accent" /> : items.length === 0 ? (
        <div className="text-center py-20 border border-dashed border-border rounded-md">
          <ShieldAlert className="w-8 h-8 text-muted-foreground mx-auto mb-3" strokeWidth={1.5} />
          <p className="text-muted-foreground text-sm">No complaints reported.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((c) => (
            <div key={c.id} className="bg-card border border-border rounded-md p-4 flex items-start justify-between gap-4" data-testid={`complaint-${c.id}`}>
              <div>
                <div className="flex items-center gap-2">
                  <p className="text-foreground font-medium">{c.category}</p>
                  <Badge className={`${statusColor[c.status]} border-0 capitalize`}>{c.status.replace("_", " ")}</Badge>
                </div>
                <p className="text-sm text-muted-foreground mt-0.5">{c.guest_name} · Room {c.room || "—"}</p>
                <p className="text-sm text-foreground mt-2">{c.description}</p>
                <p className="text-xs text-muted-foreground mt-1">{new Date(c.created_at).toLocaleString()}</p>
              </div>
              <Select value={c.status} onValueChange={(v) => setStatus(c.id, v)}>
                <SelectTrigger className="w-40 shrink-0" data-testid={`complaint-status-${c.id}`}><SelectValue /></SelectTrigger>
                <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s} className="capitalize">{s.replace("_", " ")}</SelectItem>)}</SelectContent>
              </Select>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
